import { formatPrice as utilsFormatPrice } from '~/utils';

import { PriceTypes } from '../routes/select-treatment/constants';

export const formatDuration = (duration) => {
  const minutes = Math.floor((duration / (1000 * 60)) % 60);
  const hours = Math.floor((duration / (1000 * 60 * 60)) % 24);

  return [hours && `${hours}h`, minutes && `${minutes}mins`].filter(Boolean).join(' ').trim();
};

export const formatPrice = (priceType, price) => {
  const formatedPrice = utilsFormatPrice(price);

  if (formatedPrice !== 'Free') {
    if (priceType === PriceTypes.REDEEMABLE) {
      return `${price} (redeemable against purchase)`;
    }
    if (priceType === PriceTypes.VARIABLE) {
      return `From ${price}`;
    }
  }

  return formatedPrice;
};

export const formatters = {
  formatDuration,
  formatPrice,
};
